module.exports = __webpack_public_path__ + "img/lotusflower.e1d1074f.png";